import React, { useState, useEffect, useContext } from 'react'
import DataTable from './DataTable'
import { KTSVG } from '../../_metronic/helpers'
import Swal from 'sweetalert2'
import ProductCreate from './ProductCreate'
import ProductImageUploader from './ProductImageUploader'
import ProductBomCreateModal from './ProductBomCreateModal'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import { Link } from 'react-router-dom'
import { AppContext } from '../context/AppContext'
import 'react-loading-skeleton/dist/skeleton.css'

const ProductList = () => {
	const { currentUser } = useContext(AppContext);
	const showBomExport = Number(currentUser?.id) === 3;

	const jwt = () => {
		const myToken = localStorage.getItem('MyToken');
		return myToken != null ? JSON.parse(myToken) : '';
	};

	const [newData, setNewData] = useState<any>({});
	const [createProductModalShow, setCreateProductModalShow] = useState(false);
	const [id, setId] = useState(0);
	const [projects, setProjects] = useState<any[]>([]);
	const [project, setProject] = useState<any>({ label: 'All Project', value: '' });
	const [imageProduct, setImageProduct] = useState<any>(null);
	const [showProductImageModal, setShowProductImageModal] = useState(false);
	const [showProductBomCreateModal, setShowProductBomCreateModal] = useState(false);
	const [bomCreateProduct, setBomCreateProduct] = useState<any>(null);

	useEffect(() => {
		fetch(process.env.REACT_APP_API_URL + 'projects', getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				const projectOptions = resp.data.map((item: any) => ({
					label: item.project_name,
					value: item.id_projects,
				}));
				setProjects([{ label: 'All Project', value: '' }, ...projectOptions]);
			})
			.catch((error) => console.log(error, 'catch the hoop'));
	}, []);

	const reloadTable = () => setNewData({ id: Date.now() });

	const handleCreateProductModalShow = () => {
		setId(0);
		setCreateProductModalShow(true);
	};

	const handleCreateProductModalClose = (isReload: boolean) => {
		setCreateProductModalShow(false);
		if (isReload) {
			reloadTable();
		}
	};

	const editProduct = (productId: number) => {
		setId(productId);
		setCreateProductModalShow(true);
	};

	const showImageUploader = (row: any) => {
		setImageProduct({
			idProducts: row.idProducts,
			productName: row.productName,
			size: row.size,
			packing: row.packing,
		});
		setShowProductImageModal(true);
	};

	const handleProductImageUploaderClose = () => {
		setShowProductImageModal(false);
		reloadTable();
	};

	const showBomCreator = (row: any) => {
		setBomCreateProduct({
			idProducts: row.idProducts,
			productName: row.productName,
		});
		setShowProductBomCreateModal(true);
	};

	const handleProductBomCreateClose = (saved?: boolean) => {
		setShowProductBomCreateModal(false);
		setBomCreateProduct(null);
		if (saved) {
			reloadTable();
		}
	};

	const parseBomList = (bomList: string | null) => {
		if (!bomList) {
			return [];
		}
		return bomList.split('|').map((entry) => {
			const [id, ...nameParts] = entry.split(':');
			return { id: Number(id), name: nameParts.join(':') };
		}).filter((bom) => bom.id && bom.name);
	};

	const confirmVerifyProduct = async (idProducts: number, type: 'Yes' | 'No') => {
		const isVerified = type === 'Yes';
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: isVerified
				? 'Do you want to Verify this Product?'
				: 'Do you want to Unverify this Product?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: isVerified ? 'Yes, Verify it!' : 'Yes, Unverify it!',
		});

		if (!confirm.value) {
			return;
		}

		try {
			const response = await fetch(
				`${process.env.REACT_APP_API_URL}confirmVerifyProduct/${idProducts}/${type}`,
				postRequestOptions()
			);
			const respData = await response.json();
			if (respData.success === true) {
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: isVerified ? 'Product has been verified.' : 'Product has been unverified.',
				});
				reloadTable();
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'Could not update product verification status.',
				});
			}
		} catch (error) {
			console.log(error, 'catch the hoop');
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Could not update product verification status.',
			});
		}
	};

	const confirmStatusProduct = async (idProducts: number, status: 'Active' | 'Inactive') => {
		const isActive = status === 'Active';
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: isActive
				? 'Do you want to Activate this Product?'
				: 'Do you want to Deactivate this Product?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: isActive ? 'Yes, Activate it!' : 'Yes, Deactivate it!',
		});

		if (!confirm.value) {
			return;
		}

		try {
			const response = await fetch(
				`${process.env.REACT_APP_API_URL}confirmStatusProduct/${idProducts}/${status}`,
				postRequestOptions()
			);
			const respData = await response.json();
			if (respData.success === true) {
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: respData.successMessage || 'Product status has been updated.',
				});
				reloadTable();
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'Could not update product status.',
				});
			}
		} catch (error) {
			console.log(error, 'catch the hoop');
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Could not update product status.',
			});
		}
	};

	const deleteProduct = async (productId: number) => {
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: 'You want to delete this product?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Delete it!',
		});

		if (!confirm.value) {
			return;
		}

		try {
			const response = await fetch(
				`${process.env.REACT_APP_API_URL}deleteProduct/${productId}`,
				postRequestOptions()
			);
			const respData = await response.json();
			if (respData.success === true) {
				Swal.fire({
					icon: 'success',
					title: 'Deleted!',
					text: respData.successMessage || 'Product deleted successfully.',
				});
				reloadTable();
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					html: 'Could not delete product. It has dependant data.',
				});
			}
		} catch (error) {
			console.log(error, 'catch the hoop');
		}
	};

	const handleProjectChange = (selectedProject: any) => {
		setProject(selectedProject);
		reloadTable();
	};

	const columns = [
		{ value: 'id', title: 'Id', style: { textAlign: 'center' } },
		{ value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
		{ value: 'categoryName', title: 'Category', style: { textAlign: 'left' } },
		{ value: 'productName', title: 'Product Name', style: { textAlign: 'left' } },
		{ value: 'alternateName', title: 'Alternate Name', style: { textAlign: 'left' } },
		{ value: 'unitName', title: 'Unit', style: { textAlign: 'left' } },
		{ value: 'packing', title: 'Packing', style: { textAlign: 'center' } },
		{ value: 'size', title: 'Size', style: { textAlign: 'center' } },
		{ value: 'productionCost', title: 'Production Cost', style: { textAlign: 'right' } },
		{ value: 'salePerUnit', title: 'Sale Amount', style: { textAlign: 'right' } },
		{
			value: 'verified',
			title: 'Verified',
			style: { textAlign: 'center', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: (row: any) => (
				<>
					{row.verified === 'Yes' ? (
						<button
							type="button"
							className="btn btn-success btn-sm"
							onClick={() => confirmVerifyProduct(row.idProducts, 'No')}
						>
							Yes
						</button>
					) : (
						<button
							type="button"
							className="btn btn-danger btn-sm"
							onClick={() => confirmVerifyProduct(row.idProducts, 'Yes')}
						>
							No
						</button>
					)}
				</>
			),
		},
		{
			value: 'costSetup',
			title: 'Cost Setup',
			style: { textAlign: 'center', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: (row: any) => {
				const boms = parseBomList(row.bomList);
				if (boms.length > 0) {
					return (
						<div>
							{boms.map((bom, bomIndex) => (
								<React.Fragment key={bom.id}>
									{bomIndex > 0 && <hr className="my-1" />}
									<Link to={`/production-cost-setting/${row.idProducts}?id_product_bom=${bom.id}`}>
										{bom.name}
									</Link>
								</React.Fragment>
							))}
						</div>
					);
				}
				return (
					<button type="button" className="btn btn-warning btn-sm" onClick={() => showBomCreator(row)}>
						Create BOM
					</button>
				);
			},
		},
		{
			value: 'status',
			title: 'Status',
			style: { textAlign: 'center', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: (row: any) => (
				<>
					{row.status === 'Active' ? (
						<button
							type="button"
							className="btn btn-success btn-sm"
							onClick={() => confirmStatusProduct(row.idProducts, 'Inactive')}
						>
							Active
						</button>
					) : row.status === 'Inactive' ? (
						<button
							type="button"
							className="btn btn-danger btn-sm"
							onClick={() => confirmStatusProduct(row.idProducts, 'Active')}
						>
							Inactive
						</button>
					) : (
						<button
							type="button"
							className="btn btn-secondary btn-sm"
							onClick={() => confirmStatusProduct(row.idProducts, 'Active')}
						>
							Set Status
						</button>
					)}
				</>
			),
		},
		{
			value: 'action',
			title: 'Action',
			style: { textAlign: 'left', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: (row: any) => (
				<>
					<button type="button" className="btn btn-light-primary btn-sm p-2 me-1" onClick={() => editProduct(row.idProducts)} title="Edit">
						<KTSVG path="/media/svg/icons/Design/Edit.svg" className="svg-icon-5 svg-icon-primary me-0" />
					</button>
					<button type="button" className="btn btn-light-primary btn-sm p-2 me-1" onClick={() => showImageUploader(row)} title="Upload Image">
						<KTSVG path="/media/svg/icons/Design/Image.svg" className="svg-icon-5 svg-icon-danger me-0" />
					</button>
					<button type="button" className="btn btn-light-danger btn-sm p-2" onClick={() => deleteProduct(row.idProducts)} title="Delete">
						<KTSVG path="/media/svg/icons/General/Trash.svg" className="svg-icon-5 svg-icon-danger me-0" />
					</button>
				</>
			),
		},
	];

	const filters = {
		id: { filterType: 'like', filterValue: '' },
		projectName: { filterType: 'like', filterValue: '' },
		categoryName: { filterType: 'like', filterValue: '' },
		productName: { filterType: 'like', filterValue: '' },
		alternateName: { filterType: 'like', filterValue: '' },
		unitName: { filterType: 'like', filterValue: '' },
		packing: { filterType: 'like', filterValue: '' },
		size: { filterType: 'like', filterValue: '' },
		productionCost: { filterType: 'like', filterValue: '' },
		salePerUnit: { filterType: 'like', filterValue: '' },
		verified: { filterType: 'like', filterValue: '' },
		costSetup: { filterType: 'like', filterValue: '' },
		status: { filterType: 'like', filterValue: '' },
	};

	const additionalPostData = {
		idProjects: project?.value ?? '',
	};

	const url = process.env.REACT_APP_API_URL + 'productList';

	return (
		<>
			<div className="card card-custom">
				<div className="card-header">
					<div className="card-title">
						<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
						<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
							Product List
						</span>
					</div>
					<div className="card-toolbar d-flex flex-wrap gap-2 align-items-center">
						<div style={{ minWidth: '220px' }}>
							<Select
								value={project}
								onChange={handleProjectChange}
								options={projects}
								menuPosition="fixed"
							/>
						</div>
						<a
							target="_blank"
							rel="noreferrer"
							className="btn btn-sm btn-primary"
							href={`${process.env.REACT_APP_BACKEND}productExport?export=true&idProjects=${project?.value ?? ''}&showOnlyWithStock=false&showOnlyWithCostSetup=false&sortBySize=false&searchProduct=&token=${jwt()}`}
						>
							<i className="fas fa-download me-1" /> Export
						</a>
						{showBomExport ? (
							<a
								target="_blank"
								rel="noreferrer"
								className="btn btn-sm btn-primary"
								href={`${process.env.REACT_APP_BACKEND}bomExport?export=true&idProjects=${project?.value ?? ''}&status=showAll&token=${jwt()}`}
							>
								<i className="fas fa-download me-1" /> BOM Export
							</a>
						) : null}
						{showBomExport ? (
							<a
								target="_blank"
								rel="noreferrer"
								className="btn btn-sm btn-primary"
								href={`${process.env.REACT_APP_BACKEND}bomExport?export=true&idProjects=${project?.value ?? ''}&status=showAll&type=Active&token=${jwt()}`}
							>
								<i className="fas fa-download me-1" /> Active BOM Export
							</a>
						) : null}
						<button type="button" className="btn btn-sm btn-primary" onClick={handleCreateProductModalShow}>
							<i className="fa fa-plus" /> Add Product
						</button>
					</div>
				</div>

				<div className="card-body">
					<DataTable
						url={url}
						columns={columns}
						filters={filters}
						newData={newData}
						additionalPostData={additionalPostData}
					/>
				</div>
			</div>

			<ProductCreate show={createProductModalShow} handleClose={handleCreateProductModalClose} id={id} />
			<ProductImageUploader
				show={showProductImageModal}
				handleClose={handleProductImageUploaderClose}
				id={Date.now()}
				product={imageProduct}
			/>
			<ProductBomCreateModal
				show={showProductBomCreateModal}
				handleClose={handleProductBomCreateClose}
				product={bomCreateProduct}
				defaultBomName="Default BOM"
			/>
		</>
	);
};

export default ProductList;
